export const gameTitle = "Найди пару";
export const gameText =
  'Найдите все пары за 2 минуты и получите <a href="new_year2024/Правила_участия_в_квесте.pdf" target="_blank">100 баллов</a>! Поочередно переворачивайте карточки и запоминайте спрятанные картинки и их расположение на экране.';
